import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { notifyAuthSessionUpdated } from "../../utils/authSession";
import { isMangoFeatureEnabled } from "../../utils/featureFlags";

const UserTokenHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const mangoFeatureEnabled = isMangoFeatureEnabled();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const Sundarbantoken = queryParams.get("token");

    if (Sundarbantoken) {
      // Store token - sundorbonToken is primary, token is used by some components
      localStorage.setItem("sundorbonToken", Sundarbantoken);
      localStorage.setItem("token", Sundarbantoken);

      try {
        const decoded = jwtDecode(Sundarbantoken);
        const userDetails = {
          Id: decoded.UserId,
          Name: decoded.Username || decoded.UserName,
          Type: decoded.RoleName || decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"],
          Email: decoded.sub || decoded.UserEmail,
        };
        localStorage.setItem(
          "sundorbonBookingUserDetails",
          JSON.stringify(userDetails)
        );
        notifyAuthSessionUpdated();

        // Clean up token from URL
        queryParams.delete("token");
        const newSearch = queryParams.toString();
        const cleanedPath = newSearch
          ? `${location.pathname}?${newSearch}`
          : location.pathname;

        // If we have a pricing draft keep flag, route to bookings after login
        const keepDraft = localStorage.getItem("sundorbonPricingDraftKeep");
        if (keepDraft) {
          // Check if it's a mango pricing draft
          const draftRaw = localStorage.getItem("sundorbonPricingDraft");
          const isMango = draftRaw
            ? JSON.parse(draftRaw)?.pricingType === "mango"
            : false;
          
          // Navigate to bookings with a query param to indicate mango redirect
          const bookingsPath =
            isMango && mangoFeatureEnabled ? "/?openMangoBooking=1" : "/bookings";
          navigate(bookingsPath, { replace: true });
          
          // Clear the flag after navigation
          localStorage.removeItem("sundorbonPricingDraftKeep");
        } else {
          navigate(cleanedPath, { replace: true });
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [location.search, navigate, location.pathname, mangoFeatureEnabled]);
};

export default UserTokenHandler;
